import { appColors } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { CareerPathWithScore } from '@backrs_ui/grow-ui/src/models/models';

import { Box, Typography, SxProps, Theme } from '@mui/material';

import { getCareerPathFitColor } from '../util/results.util';

const BEST_FIT_CAREER_PATH_STRINGS = appStrings.modules.results;

type BestFitCareerPathsProps = Readonly<{
  topFiveCareerPathsWithScore: CareerPathWithScore[];
  setCurrentDialogCareerPath: (careerPath: CareerPathWithScore) => void;
}>;

export const BestFitCareerPaths = ({
  topFiveCareerPathsWithScore,
  setCurrentDialogCareerPath,
}: BestFitCareerPathsProps) => {
  return (
    <Box sx={bestFitCareerPathsContainerStyle}>
      <Box>
        <Typography variant="h4" sx={bestFitTitleStyle}>
          {BEST_FIT_CAREER_PATH_STRINGS.bestFitCareerPath}
        </Typography>
        <Typography variant="body1" sx={sectionDescriptionStyle}>
          {BEST_FIT_CAREER_PATH_STRINGS.sectionDescriptions.bestFit}
        </Typography>
      </Box>

      {topFiveCareerPathsWithScore.map((path, index) => (
        <Box key={index} onClick={() => setCurrentDialogCareerPath(path)} sx={careerPathStyle}>
          <Box sx={lineItemContainerStyle}>
            <Box sx={blueCircleStyle} />
            <Box>
              <Typography variant="h6" sx={careerPathNameStyle}>
                {path.careerPath.name}
              </Typography>
            </Box>
          </Box>
          <Typography variant="body1" ml={'1.5rem'}>
            {path.careerPath.description}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

const careerPathNameStyle: SxProps<Theme> = {
  fontWeight: 700,
  lineHeight: '1.25',
  pb: 0.5,
};

const bestFitTitleStyle: SxProps<Theme> = {
  fontSize: '32px',
  fontWeight: 'bold',
  mb: 2,
  '@media (max-width: 656px)': {
    fontSize: '24px',
  },
};

const sectionDescriptionStyle: SxProps<Theme> = {
  fontStyle: 'italic',
  fontSize: '14px',
  lineHeight: '1.25',
  mb: {
    xs: 1,
    sm: 2,
    md: 3,
  },
};

const bestFitCareerPathsContainerStyle: SxProps<Theme> = {
  backgroundColor: appColors.neutral.white,
  border: `2px solid ${appColors.neutral.black}`,
  borderRadius: '.5rem',
  paddingX: {
    xs: '1rem',
    sm: '2rem',
  },
  paddingTop: '2rem',
  paddingBottom: '2rem',
  width: {
    xs: 'unset',
    sm: 'unset',
    md: '36.5%',
  },
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

const lineItemContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1,
};

const careerPathStyle: SxProps<Theme> = {
  cursor: 'pointer',
  color: appColors.neutral.black,
  '&:hover': {
    color: `${appColors.neutral.black}60`,
  },
};

const blueCircleStyle: SxProps<Theme> = {
  backgroundColor: getCareerPathFitColor('TOP'),
  borderRadius: '50%',
  height: '1rem',
  width: '1rem',
};
